export default __webpack_public_path__ + "static/media/analytics_donor.a2a68b3c.svg";